import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { SiteNav } from "@/components/site/SiteNav";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PageMeta } from "@/components/site/PageMeta";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "@/components/ui/sonner";
import { useNavigate } from "react-router-dom";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    // Supabase parses the recovery hash automatically and fires PASSWORD_RECOVERY
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY" || event === "SIGNED_IN") setReady(true);
    });
    supabase.auth.getSession().then(({ data }) => { if (data.session) setReady(true); });
    return () => sub.subscription.unsubscribe();
  }, []);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      toast.success("Password updated. Redirecting…");
      setTimeout(() => nav("/members", { replace: true }), 800);
    } catch (err) {
      toast.error((err as Error).message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-navy-deep text-white">
      <PageMeta path="/reset-password" title="Reset password" description="Set a new password." noindex />
      <SiteNav />
      <main className="container max-w-md py-16">
        <h1 className="font-display font-bold uppercase text-3xl mb-4">Set a new password</h1>
        {!ready ? (
          <p className="text-silver">Open the link from your email on this device to reset your password.</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input type="password" required minLength={8} placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-navy border-border text-white" />
            <Button disabled={busy} type="submit" className="w-full bg-cta text-white font-display uppercase tracking-[0.2em] py-6 shadow-cta">
              {busy ? "…" : "Update password"}
            </Button>
          </form>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
